<template>
  <div class="row">
    <div class="col-md-12 pb-0 pt-0">
      <h6 class="upper-text">Período de validação da prescrição</h6>
    </div>
    <div class="col-md-12">
      <div class="col-xl-12 v-clean pt-0 pl-0 pr-0 pb-2">
        <h6 class="upper-text text-fourteen worksansr p-2 mb-0 text-center">
          <i
            class="fas fa-exclamation-circle color-warning text-twenty mr-1"
          ></i>
          FREQUÊNCIA
        </h6>
        <h6 class="upper-text pl-2 mb-0 text-center">
          <strong v-if="type == 'NORMAL'">DIÁRIO/SEMANAL/EVENTUAL</strong>
          <strong v-if="type == 'LONGO_PRAZO'">SEMANAL/MENSAL/ANUAL</strong>
        </h6>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
      <label>DATA DE INÍCIO</label>
      <input v-model="start_date" type="date" class="form-control" />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
      <label>DATA DE TÉRMINO</label>
      <input v-model="end_date" type="date" class="form-control" />
    </div>
    <div class="col-md-12">
      <SelectResidentID
        v-show="show_resident_id"
        :disabled="disabled_resident_id"
        refautofocus
        v-model="resident_id"
      />
    </div>
    <div class="col-md-12">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn :disabled="loading" @click="create" class="btn-save"
        ><i class="fas fa-save mr-2 text-twenty"></i>
        {{ loading ? "CARREGANDO" : "SALVAR" }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import SelectResidentID from "../../../templates/Components/SelectResidentID";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

export default {
  name: "Medicine",
  components: {
    ErrorsMessages,
    SelectResidentID,
  },
  props: {
    resident_id: [String, Number],
    disabled_resident_id: Boolean,
    show_resident_id: { type: Boolean, default: true },
    type: String,
  },
  data() {
    return {
      loading: false,
      start_date: "",
      end_date: "",
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {},
    async create() {
      try {
        this.loading = true;

        let { resident_id, start_date, end_date, type } = this;

        let params = {
          resident_id,
          start_date,
          end_date,
          type,
        };

        const response = await api.post(
          "/rest-home/group-prescription-medicine",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("create", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
